import { lazy } from 'react';

// USER SECTION — the exam screens, which have no new design
const UserMockExam = lazy(() => import('./user section/MockExam'));
const UserFreqExam = lazy(() => import('./user section/FreqExamPage'));
const UserExamReview = lazy(() => import('./user section/ExamReview'));
const UserExamCorrection = lazy(() => import('./user section/ExamCorrection'));
const UserNotifications = lazy(() => import('./user section/Notifications'));

// PUBLIC SECTION — the pages an issued badge and attendance certificate link to
const PublicBadgeRelease = lazy(() => import('./public section/BadgeRelease'));
const PublicCertAttendRelease = lazy(() => import('./public section/CertAttendRelease'));
const UserInteractiveBooks = lazy(() => import('./user section/InteractiveBook'));
const UserInteractiveBookDetails = lazy(() => import('./user section/InteractiveBook/Details'));


// ADMIN SECTION
const Profile = lazy(() => import('./admin section/Profile'));
// Roles
const AdminRoles = lazy(() => import('./admin section/Roles/Roles'));
// Program
const AdminCerts = lazy(() => import('./admin section/Program/Cerifications'));
const AdminCourses = lazy(() => import('./admin section/Program/Courses'));
const AdminOneDayCourses = lazy(() => import('./admin section/Program/OneDayCourses'));
const AdminUnits = lazy(() => import('./admin section/Program/Units'));
const AdminTopics = lazy(() => import('./admin section/Program/Topics'));
const AdminUploadVideos = lazy(() => import('./admin section/Program/UploadVideos'));
const AdminUploadBooks = lazy(() => import('./admin section/Program/UploadBooks'));
const AdminCourseResources = lazy(() => import('./admin section/Program/CourseResources'));

// Questions
const AdminQuestionsMcqsNew = lazy(() => import('./admin section/Questions/Mcqs/QuestionsMcqsNew'));
const AdminQuestionsEssay = lazy(() => import('./admin section/Questions/Essay/QuestionsEssay'));
const AdminQuestionsMcqs = lazy(() => import('./admin section/Questions/Mcqs/QuestionsMcqs'));
const AdminQuestionsText = lazy(() => import('./admin section/Questions/Text/QuestionsText'));
const AdminQuestionsComposite = lazy(() => import('./admin section/Questions/Composite'));
const AdminQuestionsFile = lazy(() => import('./admin section/Questions/File'));
const AdminSizes = lazy(() => import('./admin section/Questions/Sizes'));
// Packages
const AdminPackages = lazy(() => import('./admin section/Packages/Packages'));
const AdminPackageProperties = lazy(() => import('./admin section/Packages/Properties'));
const AdminPackagesPolicies = lazy(() => import('./admin section/Packages/Policies'));
const AdminPackagesCategories = lazy(() => import('./admin section/Packages/Categories'));
const AdminPackagesPacks = lazy(() => import('./admin section/Packages/Packs'));

// Subscriptions
const AdminSubscriptions = lazy(() => import('./admin section/Subscriptions/Subscriptions'));
const AdminPromotions = lazy(() => import('./admin section/Subscriptions/Promotions'));
// Stakeholders
const AdminAdmins = lazy(() => import('./admin section/Stakeholders/Admins'));
const AdminUsers = lazy(() => import('./admin section/Stakeholders/Users'));
// Generals
const AdminDashboard = lazy(() => import('./admin section/Dashboard'));
const AdminNews = lazy(() => import('./admin section/News'));
// Instructors
const AdminInstructors = lazy(() => import('./admin section/Instructors/Instructors'));
// Team Members
const AdminTeamMembers = lazy(() => import('./admin section/TeamMembers/TeamMembers'));
// FAQs
const AdminFAQs = lazy(() => import('./admin section/FAQs/FAQs'));
// Success Stories
const AdminSuccessStories = lazy(() => import('./admin section/SuccessStories/SuccessStories'));
// Reports
const AdminPaymentsReport = lazy(() => import('./admin section/Reports/PaymentsReport'));
const AdminManualPayments = lazy(() => import('./admin section/Reports/ManualPayments'));
const AdminContentReports = lazy(() => import('./admin section/Reports/ContentReports'));
const AdminUserPerformance = lazy(() => import('./admin section/Reports/Performance/UserPerformance'));
const AdminUsersPerformances = lazy(() => import('./admin section/Reports/Performance/UsersPerformances'));
// Exams
const AdminMockExams = lazy(() => import('./admin section/Exams/MockExamsManagement'));
const AdminExams = lazy(() => import('./admin section/Exams/ExamsManagement'));

// Exam Correction
const AdminExamCorrection = lazy(() => import('./admin section/Exams/ExamCorrection'));
// Courses Calendar
const AdminCoursesCalendar = lazy(() => import('./admin section/Calendar'));
// Messages
const AdminMessages = lazy(() => import('./admin section/Messages'));
// Settings
const AdminIpLogs = lazy(() => import('./admin section/Settings/IpLogSettings/IpLogs'));
const AdminNotifications = lazy(() => import('./admin section/Settings/NotificationsSettings'));
const AdminPolicyTermsSettings = lazy(() => import('./admin section/Settings/AdminPolicyTermsSettings'));
// HONOR ROLL
const AdminHonorRoll = lazy(() => import('./admin section/HonorRoll'));
// Blogs
const AdminBlogs = lazy(() => import('./admin section/Blogs'));
const AdminBlogsCategories = lazy(() => import('./admin section/Blogs/Categories'));
const AdminBlogsTags = lazy(() => import('./admin section/Blogs/Tags'));
const AdminInteractiveBookEditor = lazy(() => import('./admin section/InteractiveBook/Editor'));
const AdminInteractiveBooks = lazy(() => import('./admin section/InteractiveBook'));
// Badges and Attendance
const AdminCertAttendance = lazy(() => import('./admin section/BadgesAttendance/Attendance'));
const AdminCertUserAttendance = lazy(() => import('./admin section/BadgesAttendance/UserAttendance'));
const AdminBadges = lazy(() => import('./admin section/BadgesAttendance/Badges'));
const AdminUserBadges = lazy(() => import('./admin section/BadgesAttendance/UserBadges'));

// Companes
const AdminCompanies = lazy(() => import('./admin section/Companies/Companies'));
const AdminCompaniesCourses = lazy(() => import('./admin section/Companies/Courses'));
const AdminCompaniesProposals = lazy(() => import('./admin section/Companies/Proposals'));
const AdminCompaniesRequests = lazy(() => import('./admin section/Companies/BusinessRequests'));

const AdminBanners = lazy(() => import('./admin section/Banners'));
const AdminAccredits = lazy(() => import('./admin section/Accredits'));



export {
    UserMockExam, UserExamReview, UserFreqExam, UserNotifications, UserExamCorrection,

    PublicBadgeRelease, PublicCertAttendRelease,UserInteractiveBooks, UserInteractiveBookDetails,

    Profile,
    AdminDashboard, AdminAdmins, AdminUsers, AdminSubscriptions, AdminCerts, AdminCourses, AdminUnits, AdminTopics,
    AdminQuestionsMcqsNew, AdminSizes, AdminOneDayCourses, AdminPackages, AdminPackageProperties, AdminPackagesPacks,
    AdminRoles, AdminPromotions, AdminQuestionsEssay, AdminQuestionsMcqs, AdminQuestionsText, AdminQuestionsComposite,
    AdminQuestionsFile, AdminUploadVideos, AdminUploadBooks, AdminCourseResources,
    AdminNews, AdminInstructors, AdminSuccessStories,
    AdminPaymentsReport, AdminManualPayments, AdminContentReports, AdminUserPerformance, AdminUsersPerformances,
    AdminIpLogs, AdminExams, AdminMockExams, AdminExamCorrection, AdminCoursesCalendar, AdminMessages, AdminNotifications,
    AdminHonorRoll, AdminPolicyTermsSettings, AdminTeamMembers, AdminPackagesPolicies, AdminPackagesCategories,
    AdminBlogs, AdminBlogsCategories, AdminBlogsTags, AdminInteractiveBooks, AdminInteractiveBookEditor, AdminFAQs,
    AdminCompanies, AdminCompaniesCourses, AdminCompaniesProposals, AdminCompaniesRequests,
    AdminCertAttendance, AdminCertUserAttendance, AdminBadges, AdminUserBadges,
    AdminBanners, AdminAccredits,
};
